import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ApexChart, ApexNonAxisChartSeries, ApexResponsive} from "ng-apexcharts";
import {of} from "rxjs";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  colors:string[];
  plotOptions: {
    pie: {
      size: number
    }
  };
  dataLabels: {
    enabled: boolean;
    formatter: (val: number, context: object) => any;
    textAnchor?: 'start' | 'middle' | 'end';
    style?: { fontSize?: string; fontFamily?: string };
  };
};
@Component({
  selector: 'app-apex-piechart',
  templateUrl: './apex-piechart.component.html',
  styleUrls: ['./apex-piechart.component.scss']
})
export class ApexPiechartComponent implements OnInit,AfterViewInit {
  mChartData: number[] = []
  mLabels: string[] = []
  mColors: string[] = ["#ed7d31", '#70ad47', '#FFC000' ]
  public chartOptions!: Partial<ChartOptions>;

  // Separate typed-as-any config to ensure all ApexCharts properties pass through
  // Threshold below which labels are suppressed inside the slice.
  // The summary row below the chart always shows all values.
  private readonly LABEL_MIN_PCT = 8;

  dataLabelsConfig: any = {
    enabled: true,
    textAnchor: 'middle',
    distributed: false,
    offsetX: 0,
    offsetY: 0,
    style: { fontSize: '14px' },
    formatter: (val: number, opts: any) => {
      if (val < this.LABEL_MIN_PCT) return ''; // slice too small — shown in summary row
      const emojis = ['😠', '😊', '😐'];
      const emoji = emojis[opts?.seriesIndex] ?? '';
      return [`${Number(val).toFixed(1)}%`, emoji];
    }
  };

  @Input() chartLabels: string[] = [];
  @Input() chartData:  number[]  = [];
  @Input() chartTitle: string = '';
  @Input() mWidth: number = 450;

  constructor(
      readonly changeDetector: ChangeDetectorRef
  ) {

    console.log('in apex chart labels are:',this.chartLabels)
    console.log('in apex chart data are:',this.chartData)


    this.chartOptions = {
      // @ts-ignore
      plotOptions: {
        pie: {
          size: 300
        }
      },
      series:[... this.chartData],
      chart: {
        width: this.mWidth,
        type: "pie"
      },
      // labels: [...this.chartLabels],
      colors:["#ed7d31", '#70ad47', '#FFC000' ],
      dataLabels: this.dataLabelsConfig,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "center"
            }
          }
        }
      ]
    };



  }

  ngOnInit(): void {

  }

  get summaryRows(): { emoji: string; label: string; percentage: string; color: string }[] {
    const total = this.mChartData.reduce((a, b) => a + b, 0);
    const emojis = ['😠', '😊', '😐'];
    return this.mChartData.map((val, i) => ({
      emoji: emojis[i] ?? '',
      label: this.chartLabels[i] ?? '',
      percentage: total > 0 ? ((val / total) * 100).toFixed(1) : '0.0',
      color: this.mColors[i] ?? '#ccc',
    }));
  }

  ngAfterViewInit(): void {
    of(this.chartData).subscribe(chartDataRes => {
      this.mChartData = [...chartDataRes];
    });

    of(this.chartLabels).subscribe(chartLabelsRes => {
      // Legend labels are shown as-is (no emoji prefix).
      this.mLabels = [...chartLabelsRes];

      this.chartOptions.series = [...this.mChartData];
      this.chartOptions.labels = [...this.mLabels];
      this.chartOptions.colors = this.mColors;

      this.changeDetector?.detectChanges();

      console.log(this.mLabels.toString() + ' in apex pie chart ' + this.mChartData.toString());
    });
  }





}
